import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'profile--barreau-edit-modal'
    ];

    openEditModal(event) {
        event.preventDefault();
        this.profileBarreauEditModalOutlet.openModal();
    }
}
